// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_IuX","cls2":"ProfilePdfPackCard-cls2_ubl ProfilePdfPackCard-cls1_IuX"};